import useSWR from 'swr';
import { tryCatch } from '~/core/utils/tryCatch';

const fetcher = async () => {
  // 1. Try Binance API
  const { data: binanceData, error: binanceError } = await tryCatch(
    fetch('https://api.binance.com/api/v3/ticker/24hr?symbol=ETHUSDT')
      .then(res => {
        if (!res.ok) throw new Error('Binance API failed');
        return res.json();
      })
      .then(data => data.lastPrice)
  );

  if (!binanceError) return binanceData;

  // 2. Try Coinbase API
  const { data: coinbaseData, error: coinbaseError } = await tryCatch(
    fetch('https://api.coinbase.com/v2/prices/ETH-USD/spot')
      .then(res => res.json())
      .then(data => data.data.amount)
  );

  if (!coinbaseError) return coinbaseData;

  // 3. Try CoinGecko API
  const { data: coingeckoData, error: coingeckoError } = await tryCatch(
    fetch('https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd')
      .then(res => res.json())
      .then(data => data.ethereum.usd)
  );

  if (!coingeckoError) return coingeckoData;

  // 4. Try CryptoCompare API
  const { data: cryptoCompareData, error: cryptoCompareError } = await tryCatch(
    fetch('https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD')
      .then(res => res.json())
      .then(data => data.USD)
  );

  if (!cryptoCompareError) return cryptoCompareData;

  console.error('API error:', binanceError || coinbaseError || coingeckoError || cryptoCompareError);

  return 3000; // Return default value if all APIs fail
}

export const useEthPrice = () => {
  const { data: _data, isLoading, error, mutate } = useSWR('eth-price', fetcher, {
    dedupingInterval: 1000 * 60 * 15, // 15m
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })

  const data = Math.ceil(_data ?? 0)
  return { data, isLoading: isLoading || data === 0, error, mutate }
}
